export default "__VITE_ASSET__ea6ec66a__"